import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-5 flex flex-col gap-2 md:mt-8 md:flex-row md:gap-14 xl:gap-20',
    collapseButton:
      'heading-xs-bold justify-start px-0 tracking-wider max-md:mb-3 md:hidden',
    arrow: 'm-1 transition-transform',
    products: 'flex flex-col gap-6 md:gap-4'
  }
});
